import React, { useContext } from "react";
import { AuthContext } from "../context/auth";
import moment from "moment";

function Footers() {
  const { user } = useContext(AuthContext);
  const fechaSistema = sessionStorage.getItem("fechasistema");

  const footers = user && (
    <footer className="h-10 m-0 text-center amanecerfooter p-2" id="gg">
      <strong>
        Copyright &copy; {moment(fechaSistema).format("YYYY")}{" "}
        <a
          className="bluez-text"
          href="http://www.opensiap.com.ve"
          target="_blank"
        >
          SYGRECA.
        </a>
        Todos los Derechos Reservados.
      </strong>
    </footer>
  );

  return footers;
}

export default Footers;



// WEBPACK FOOTER //
// ./src/components/foother.js